import React, { useImperativeHandle, memo, forwardRef, useRef } from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import SingleDatePicker from "./SingleDatePicker";

import t from "../constants/localization";
import color from "@constants/color";

const PATH = "components/DatePicker";

const DatePicker = memo(
  forwardRef((props, ref) => {
    const fromDateRef = useRef();
    const toDateRef = useRef();

    const {
      dates: { toDate = "", fromDate = "" },
      handleDateChanged = () => {},
    } = props;

    useImperativeHandle(ref, () => ({
      getDates: () => {
        return [fromDateRef.current.getDate(), toDateRef.current.getDate()];
      },
    }));

    return (
      <View style={[styles.beLikeRow, { justifyContent: "space-evenly" }]}>
        <SingleDatePicker
          width="35%"
          title={t(`${PATH}/from`)}
          datePlaceholder={t(`${PATH}/selectDate`)}
          titleColor={color.mediumBlack}
          ref={fromDateRef}
          date={fromDate || null}
          maximumDate={new Date()}
          handleDateChanged={function () {
            handleDateChanged.apply(null, [{ type: "fromDate" }, ...arguments]);
          }}
        />
        <Text style={{ color: color.mediumBlack, top: -10 }}>-</Text>
        <SingleDatePicker
          width="35%"
          title={t(`${PATH}/to`)}
          datePlaceholder={t(`${PATH}/selectDate`)}
          titleColor={color.mediumBlack}
          ref={toDateRef}
          date={toDate || null}
          minimumDate={fromDate ? new Date(fromDate) : new Date()}
          handleDateChanged={function () {
            handleDateChanged.apply(null, [{ type: "toDate" }, ...arguments]);
          }}
        />
      </View>
    );
  }),
);

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
    margin: 12,
  },
});

export default DatePicker;
